function SelectOption(props) {

    return(
        <option value={props.value}>{props.label}</option>
    );
}

export default SelectOption;